// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_emprestimo {
  margin: 1.9em;
  height: 100%;
}

h1 {
  font-weight: normal;
  font-family: "Roboto";
}

.input_emprestimo {
  margin-top: 1.5em;
  background-color: var(--cor-roxoInput);
  border: none;
  width: 98.5%;
  height: 50px;
  border-radius: 8px;
  font-size: 1em;
}

.input_emprestimo::placeholder {
  font-weight: 300;
  font-family: inherit;
  font-family: "Roboto";
  font-weight: 400;
}

.input_emprestimo:focus {
  outline: none;
}

.btn_pesquisar {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-25%);
  border: none;
  background-color: transparent;
  cursor: pointer;
  border-radius: 80px;
}

.btn_pesquisar:hover {
  background-color: var(--cor-roxoClaro);
}

.input_emprestimo:hover {
  background-color: var(--cor-roxoClaro);
  
}

.caixa_buscar {
  position: relative;
}

.input_emprestimo[type="text"] {
  padding-left: 25px;
}

.div_tabela {
  margin-top: 1.5em;
  height: 72%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.status_container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status_emDia {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: var(--cor-verde);
}

.status_emAtraso {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: var(--cor-vermelho);
}

.status_vazio{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--cor-azul);
}

.ENTREGUE{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--cor-azul);
}

.msg_dadoNaoEncontrado {
  margin-top: 5%;
  font-size: large;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/paginas/funcionario/Emprestimo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;;AAExC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".container_emprestimo {\n  margin: 1.9em;\n  height: 100%;\n}\n\nh1 {\n  font-weight: normal;\n  font-family: \"Roboto\";\n}\n\n.input_emprestimo {\n  margin-top: 1.5em;\n  background-color: var(--cor-roxoInput);\n  border: none;\n  width: 98.5%;\n  height: 50px;\n  border-radius: 8px;\n  font-size: 1em;\n}\n\n.input_emprestimo::placeholder {\n  font-weight: 300;\n  font-family: inherit;\n  font-family: \"Roboto\";\n  font-weight: 400;\n}\n\n.input_emprestimo:focus {\n  outline: none;\n}\n\n.btn_pesquisar {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-25%);\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  border-radius: 80px;\n}\n\n.btn_pesquisar:hover {\n  background-color: var(--cor-roxoClaro);\n}\n\n.input_emprestimo:hover {\n  background-color: var(--cor-roxoClaro);\n  \n}\n\n.caixa_buscar {\n  position: relative;\n}\n\n.input_emprestimo[type=\"text\"] {\n  padding-left: 25px;\n}\n\n.div_tabela {\n  margin-top: 1.5em;\n  height: 72%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.status_container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.status_emDia {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: var(--cor-verde);\n}\n\n.status_emAtraso {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: var(--cor-vermelho);\n}\n\n.status_vazio{\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: var(--cor-azul);\n}\n\n.ENTREGUE{\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: var(--cor-azul);\n}\n\n.msg_dadoNaoEncontrado {\n  margin-top: 5%;\n  font-size: large;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
